import type { FetcherAxiosInstance } from '../fetcher';

interface IGetCLP {
  clpId: string;
  territoryId: string | number;
}

export const createContentLandingPagesApi = (Fetcher: FetcherAxiosInstance) => ({
  getCLP(props: IGetCLP) {
    const { clpId, territoryId } = props;

    return Fetcher.get('/clp', {
      params: {
        pathname: `clp/${clpId}`,
        territoryId,
      },
    });
  },
});
